"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticsEventNames;
(function (AnalyticsEventNames) {
    AnalyticsEventNames["PAGE_VIEW_EVENT"] = "pageViewEvent";
})(AnalyticsEventNames = exports.AnalyticsEventNames || (exports.AnalyticsEventNames = {}));
